/**
 * @desc 托盘详情列表
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(params: API.wms.inPlateMaster.palteDetailList.Params, options?: any) {
  return updateResponse(
    http(URL + `/inPlate/palteDetailList`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
